<template>
  <div class="main-container">

    <div class="container" v-if="optional_data.get != ''">
      <div class="column-75 page-middle">

        <h2><span v-if="$store.state.optional_data.doe_form.form.title">{{$store.state.optional_data.doe_form.form.title}}</span></h2>

        <h4>Please download the W9 and Affidavit forms and proceed with further instructions.</h4>

        <br><hr><br>

        <h2><timer></timer></h2>

        <div v-if="optional_data.get != undefined">
          <a id="w9_form" :href="optional_data.get.w9_form.href" target="_blank" download>
            <div class="document-download-link col-mobile-margin-100 col-tablet-margin-50 font-size-26 margin-vertical-15">
                <img src="assets/img/pdf_icon.png" alt="">
                W9 Form
            </div>
          </a>

          <a id="affidavit_form" :href="optional_data.get.affidavit_form.href" class="text-underline" target="_blank" download>
            <div class="document-download-link col-mobile-margin-100 col-tablet-margin-50 font-size-26 margin-vertical-15">
                <img src="assets/img/pdf_icon.png" alt="">
                Affidavit Form
            </div>
          </a>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
    import {computed_values} from '../mixins/computed_values'
    import {elements_classes} from '../mixins/elements_classes'

    import Timer from '../components/Timer'

    export default {
        name: "download_page",
        mixins: [computed_values, elements_classes],
        components: {
            'timer': Timer
        },
        data(){
            return{
                // this_page: 'download_page'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        }
    }
</script>

<style scoped>
</style>